const toBool = (v) => v === true || v === 'true';
export function deriveUiFlags(cfg) {
    var _a, _b, _c;
    const banner = ((_a = cfg.banner) !== null && _a !== void 0 ? _a : '').toUpperCase();
    let flags = {
        showWallets: false,
        showBarcodeOnCard: false,
        showMemberSinceOnCard: false,
        loyaltyCardImageUrl: `${(_b = cfg.assetsPrefix) !== null && _b !== void 0 ? _b : ''}/loyalty-card-background.png`,
        loyaltyCardImageFilename: 'loyalty-card-background.png',
        hideBookedFilter: false,
        hideBookedBadge: false,
    };
    switch (banner) {
        case 'SGH':
            flags.showWallets = true;
            flags.showBarcodeOnCard = true;
            break;
        case 'CDM':
            flags.hideBookedFilter = true;
            flags.hideBookedBadge = true;
            break;
        case 'CLY':
            flags.showMemberSinceOnCard = true;
            flags.showWallets = true;
            if (['AU', 'NZ'].includes(((_c = cfg.country) !== null && _c !== void 0 ? _c : '').toUpperCase())) {
                flags.loyaltyCardImageFilename = 'loyalty-card-background-au-nz.png';
            }
            break;
        default:
            if (toBool(cfg.digitalCard)) {
                flags.showWallets = true;
                flags.showBarcodeOnCard = true;
            }
    }
    return flags;
}
//# sourceMappingURL=lxl-derive-ui.js.map